import React, { Component } from 'react';
import GeneralUid from '../generalUid';
import Util from '../../script/util';
import './PrettyNum.scss';

class PrettyNum extends Component {
  render() {
    const { uid, align, num, color, textAlign, style, isBright } = this.props;
    return (
      <div className="pretty-num-wrapper" style={style}>
        {num ? (
          <div
            style={{ margin: align ? '0 auto' : '', textAlign }}
            className={Util.classNames('pretty', { 'is-bright': isBright })}
          >
            <span className="icon-no" />
            <span className="no">{num}</span>
          </div>
        ) : (
          <GeneralUid color={color} style={{ textAlign }} uid={uid} />
        )}
      </div>
    );
  }
}
PrettyNum.defaultProps = {
  textAlign: 'center',
  style: {},
  isBright: false,
};

export default PrettyNum;
